export const MessageValidationSchema = {
    message: [
        { rule: "required", message: "" },
    ],
}